/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/href-no-hash */
import classNames from 'classnames'
import { find, isEmpty, isString, omit, pick, pickBy } from 'lodash'
import moment from 'moment'
import pluralize from 'pluralize'
import PropTypes from 'prop-types'
import React from 'react'
import { Redirect } from 'react-router-dom'
import uniqid from 'uniqid'

import Button from 'components/Button'
import Buttons from 'components/Buttons'
import Field from 'components/Field'
import Fields from 'components/Fields'
import Fieldset from 'components/Fieldset'
import FieldWithInput from 'components/FieldWithInput'
import FieldWithInputRadios from 'components/FieldWithInputRadios'
import FirebaseImage from 'components/FirebaseImage'
import Heading from 'components/Heading'
import Icon from 'components/Icon'
import Image from 'components/Image'
import Input from 'components/Input'
import InputAddress from 'components/InputAddress'
import InputCheckbox from 'components/InputCheckbox'
import FieldWithAddress from 'components/FieldWithAddress'
import FieldWithInputCheckboxes from 'components/FieldWithInputCheckboxes'
import InputDate from 'components/InputDate'
import InputSelect from 'components/InputSelect'
import Label from 'components/Label'
import Meta from 'components/Meta'
import ThumbnailSelectable from 'components/ThumbnailSelectable'
import ThumbnailsSelectable from 'components/ThumbnailsSelectable'
import ThumbnailsMultipleSelectable from 'components/ThumbnailsMultipleSelectable'
import inputOptions from 'constants/input-options'
import paths from 'constants/paths'
import { db } from 'data'
import createReport from 'libs/create-report'
import assertions from 'utils/assertions'

import styles from './ReportEdit.module.scss'

export default class ReportEdit extends React.Component {
  static propTypes = {
    userEmail: PropTypes.string,
  }

  static contextTypes = {
    router: PropTypes.object,
  }

  state = {
    visible: 'overview',
  }

  componentWillMount() {
    const { match, userEmail } = this.props
    const { id } = match.params

    this.setState({ id })

    db.getFullReport(id).then((snapshot) => {
      const report = snapshot.val()

      if (report) {
        this.setState(
          { report },
          () => this.checkUserIsAuthor(),
        )
      } else {
        createReport(id).then((response) => {
          this.setState(
            { report: response },
            () => this.checkUserIsAuthor(),
          )
        })
      }

      setTimeout(() => {
        console.log(this.state.report.fieldReport.images)
      }, 3000)
    })
  }

  scrollToTop = () => {
    window.scroll({
      behavior: 'smooth',
      top: 0,
    })
  }

  checkUserIsAuthor = () => {
    const { history } = this.context.router
    const { userEmail } = this.props
    const { assessorEmail } = this.state.report

    if (userEmail !== assessorEmail) {
      // currently doesn't return boolean
      //if (history.goBack) {
      //  history.goBack()
      //} else {
      //  history.push(paths.HOME)
      //}

      //history.push(paths.HOME)
    }
  }

  handleShowOverview = () => {
    this.setState({ visible: 'overview' })
  }

  handleShowAreas = () => {
    this.setState({ visible: 'areas' })
  }

  handleShowSites = () => {
    this.setState({ visible: 'sites' })
  }

  handleShowObjects = () => {
    this.setState({ visible: 'objects' })
  }

  handleShowUnassessedItems = () => {
    this.setState({ visible: 'unassessedItems' })
  }

  handleArea = (id) => {
    this.setState({
      area: isString(id) ? this.state.report.areas[id] : {},
      visible: 'area',
    })
  }

  handleSite = (id) => {
    const { report } = this.state
    const { sites = {} } = report

    this.setState({
      site: isString(id) ? sites[id] : {},
      visible: 'site',
    })
  }

  handleSiteComponent = (siteId, siteComponentId) => {
    this.setState({
      siteComponent:
        isString(siteComponentId) ?
          this.state.report.sites[siteId].components[siteComponentId] :
          { siteId },
      visible: 'site-component',
    })
  }

  handleObject = (id) => {
    const { report } = this.state
    const { objects = {} } = report

    this.setState({
      object: isString(id) ? objects[id] : {},
      visible: 'object',
    })
  }

  handleUnassessedItem = (id) => {
    this.setState({
      unassessedItem: this.state.report.unassessedItems[id],
      visible: 'unassessedItem',
    })
  }

  handleDeleteItem = () => {
    this.handleSubmit()
    this.handleShowOverview()
  }

  handleDeleteArea = () => {
    const { area, report } = this.state
    const { id: areaId } = area

    const otherAreas = omit(report.areas, [areaId])

    this.setState(
      {
        area: {},
        report: {
          ...report,
          areas: { ...otherAreas },
        },
      },
      () => this.handleDeleteItem(),
    )
  }

  handleDeleteSite = () => {
    const { report, site } = this.state
    const { id: siteId } = site

    const otherSites = omit(report.sites, [siteId])

    this.setState(
      {
        report: {
          ...report,
          sites: { ...otherSites },
        },
        site: {},
      },
      () => this.handleDeleteItem(),
    )
  }

  handleDeleteSiteComponent = () => {
    const { report, siteComponent } = this.state
    const { sites } = report
    const { id, siteId } = siteComponent

    const site = sites[siteId]
    const otherSites = omit(sites, [siteId])
    const otherSiteComponents = omit(site.components, [id])

    this.setState(
      {
        report: {
          ...report,
          sites: {
            ...otherSites,
            [siteId]: {
              ...site,
              components: { ...otherSiteComponents },
            },
          },
        },
        siteComponent: {},
      },
      () => this.handleDeleteItem(),
    )
  }

  handleDeleteObject = () => {
    const { object, report } = this.state
    const { id: objectId } = object

    const otherObjects = omit(report.objects, [objectId])

    this.setState(
      {
        object: {},
        report: {
          ...report,
          objects: { ...otherObjects },
        },
      },
      () => this.handleDeleteItem(),
    )
  }

  handleSave = () => {
    const { id, report } = this.state

    // TODEBUG: toggle next 2 lines
    //console.log('saved report', report)
    db.createOrUpdateFullReport(id, report)
  }

  handleSubmit = () => {
    this.handleSave()
    this.scrollToTop()
  }

  handleSubmitOverview = () => {
    this.handleSubmit()
    this.handleArea()
  }

  handleBackFromArea = () => {
    this.handleSubmit()
    this.handleShowOverview()
  }

  handleSubmitArea = (action = 'next') => {
    const { area, report, unassessedItems } = this.state
    //const { id: areaId = uniqid() } = area
    const areaId = area.id || uniqid()

    const otherAreas = omit(report.areas, [areaId])

    this.setState(
      {
        area: {},
        report: {
          ...report,
          areas: {
            ...otherAreas,
            [areaId]: {
              id: areaId,
              ...area,
            },
          },
          // if selected unassessed item as image, remove from unassessedItems
          unassessedItems: !isEmpty(unassessedItems) ? unassessedItems : { ...report.unassessedItems },
        },
        unassessedItems: {},
      },
      () => {
        this.handleSubmit();
        (action === 'save') ? this.handleArea(areaId) : this.handleSite()
      },
    )
  }

  handleBackFromSite = () => {
    this.handleSubmit()
    this.handleArea()
  }

  handleSubmitSite = (action = 'next') => {
    const { site, report, unassessedItems } = this.state
    //const { id: siteId = uniqid() } = site
    const siteId = site.id || uniqid()

    const otherSites = omit(report.sites, [siteId])

    this.setState(
      {
        report: {
          ...report,
          sites: {
            ...otherSites,
            [siteId]: {
              id: siteId,
              ...site,
            },
          },
          // if selected unassessed item as image, remove from unassessedItems
          unassessedItems: !isEmpty(unassessedItems) ? unassessedItems : { ...report.unassessedItems },
        },
        site: {},
        unassessedItems: {},
      },
      () => {
        this.handleSubmit();
        (action === 'save') ? this.handleSite(siteId) : this.handleObject()
      },
    )
  }

  handleSubmitSiteComponent = () => {
    const { siteComponent, report, unassessedItems } = this.state
    const { sites } = report
    const { siteId } = siteComponent

    const id = siteComponent.id || uniqid()

    const otherSites = omit(sites, [siteId])

    this.setState(
      {
        report: {
          ...report,
          sites: {
            ...otherSites,
            [siteId]: {
              ...sites[siteId],
              components: {
                ...sites[siteId].components,
                [id]: {
                  id,
                  ...siteComponent,
                },
              },
            },
          },
          // if selected unassessed item as image, remove from unassessedItems
          unassessedItems: !isEmpty(unassessedItems) ? unassessedItems : { ...report.unassessedItems },
        },
        siteComponent: {},
      },
      () => {
        this.handleSubmit()
        this.handleSiteComponent(siteId, id)
      },
    )
  }

  handleSubmitUnassessedItem = () => {
    const { report, unassessedItem } = this.state
    const { category, id: unassessedItemId } = unassessedItem
    const { areas = {}, objects = {}, sites = {}, unassessedItems = {} } = report

    const otherUnassessedItems = omit(unassessedItems, [unassessedItemId])

    if (category === 'Unknown') {
      this.setState(
        {
          visible: 'unassessedItems',
          report: {
            ...report,
            unassessedItems: {
              ...otherUnassessedItems,
              [unassessedItemId]: { ...unassessedItem },
            },
          },
          unassessedItem: {},
        },
        () => this.handleSubmit(),
      )
    } else if (category === 'Site Component') {
      this.setState(
        {
          visible: 'unassessedItems',
          report: {
            ...report,
            siteComponents: {
              [unassessedItemId]: { ...unassessedItem },
            },
            unassessedItems: { ...otherUnassessedItems },
          },
          unassessedItem: {},
        },
        () => this.handleSubmit(),
      )
    } else {
      const unassessedItemCategoryInsensitive = category.toLowerCase()

      let unassessedItemCategory = 'objects'
      let others = objects

      if (unassessedItemCategoryInsensitive === 'area') {
        unassessedItemCategory = 'areas'
        others = areas
      } else if (unassessedItemCategoryInsensitive === 'site') {
        unassessedItemCategory = 'sites'
        others = sites
      }

      this.setState(
        {
          visible: 'unassessedItems',
          report: {
            ...report,
            [unassessedItemCategory]: {
              ...others,
              [unassessedItemId]: { ...unassessedItem },
            },
            unassessedItems: { ...otherUnassessedItems },
          },
          unassessedItem: {},
        },
        () => this.handleSubmit(),
      )
    }
  }

  //handleSubmitObject = (action = 'next') => {
  handleSubmitObject = () => {
    const { object, report, unassessedItems } = this.state
    //const { id: objectId } = object
    const objectId = object.id || uniqid()

    const otherObjects = omit(report.objects, [objectId])

    this.setState(
      {
        //visible: 'objects',
        //object: action === 'save' ? object : {},
        report: {
          ...report,
          objects: {
            ...otherObjects,
            [objectId]: { ...object },
          },
          // if selected unassessed item as image, remove from unassessedItems
          unassessedItems: !isEmpty(unassessedItems) ? unassessedItems : { ...report.unassessedItems },
        },
        unassessedItems: {},
      },
      () => this.handleSubmit(),
    )
  }

  renderOverview() {
    const { report } = this.state
    const {
      assessmentDateEnd,
      assessmentDateStart,
      assessorEmail,
      assessorOrganization,
      assessorNameFirst,
      assessorNameLast,
      coverImageRef,
      coverImageUrl,
      hazardPrimary,
      hazardSecondary,
      incidentDate,
      incidentName,
      title,
      type,
    } = report
    const { areas = {}, objects = {}, sites = {}, unassessedItems = {} } = report

    const items = {
      ...areas,
      ...objects,
      ...sites,
      ...unassessedItems,
    }

    return (
      <Fieldset>
        <Heading>Overview</Heading>
        {/*
        <Field>
          <Image src={coverImageUrl} background full className={styles.img} />
        </Field>
        */}
        <Fields>
          <FieldWithInput
            input={Input}
            inputProps={{
              value: title,
            }}
            label="Report Name"
            onValidChange={(e) =>
              this.setState({
                report: {
                  ...report,
                  title: e.target.value,
                },
              })
            }
          />
          <FieldWithInput
            input={InputSelect}
            inputProps={{
              entity: 'type',
              options: inputOptions.REPORT_TYPES,
              value: type,
            }}
            label="Report Type"
            onValidChange={(e) =>
              this.setState({
                report: {
                  ...report,
                  type: e.target.value,
                },
              })
            }
          />
        </Fields>
        <Field>
          <Label>Cover Photo</Label>
          <ThumbnailsSelectable
            active={coverImageRef}
            thumbnails={items}
            onThumbnailSelect={(imageId, imageRef, imageUrl) =>
              this.setState({
                report: {
                  ...report,
                  coverImageRef: imageRef,
                  coverImageUrl: imageUrl,
                },
              })
            }
          />
        </Field>
        <Fieldset title="Assessment">
          <Fields>
            <FieldWithInput
              input={InputDate}
              inputProps={{
                value: assessmentDateStart,
              }}
              label="Start Date"
              onValidChange={(date) =>
                this.setState({
                  report: {
                    ...report,
                    assessmentDateStart: date,
                  },
                })
              }
            />
            <FieldWithInput
              input={InputDate}
              inputProps={{
                value: assessmentDateEnd,
              }}
              label="End Date"
              onValidChange={(date) =>
                this.setState({
                  report: {
                    ...report,
                    assessmentDateEnd: date,
                  },
                })
              }
            />
          </Fields>
        </Fieldset>
        <Fieldset title="Assessor">
          <Fields>
            <FieldWithInput
              input={Input}
              inputProps={{
                icon: 'user',
                value: assessorNameFirst,
              }}
              label="First Name"
              onValidChange={(e) =>
                this.setState({
                  report: {
                    ...report,
                    assessorNameFirst: e.target.value,
                  },
                })
              }
            />
            <FieldWithInput
              input={Input}
              inputProps={{
                icon: 'user',
                value: assessorNameLast,
              }}
              label="Last Name"
              onValidChange={(e) =>
                this.setState({
                  report: {
                    ...report,
                    assessorNameLast: e.target.value,
                  },
                })
              }
            />
          </Fields>
          <Fields>
            <FieldWithInput
              input={Input}
              inputProps={{
                icon: 'mail',
                type: 'email',
                value: assessorEmail,
              }}
              label="Email"
              onValidChange={(e) =>
                this.setState({
                  report: {
                    ...report,
                    assessorEmail: e.target.value,
                  },
                })
              }
            />
            <FieldWithInput
              input={Input}
              inputProps={{
                icon: 'users',
                value: assessorOrganization,
              }}
              label="Organization"
              onValidChange={(e) =>
                this.setState({
                  report: {
                    ...report,
                    assessorOrganization: e.target.value,
                  },
                })
              }
            />
          </Fields>
        </Fieldset>
        <Fieldset title="Incident">
          <Fields>
            <FieldWithInput
              input={Input}
              inputProps={{
                value: incidentName,
              }}
              label="Incident Name"
              onValidChange={(e) =>
                this.setState({
                  report: {
                    ...report,
                    incidentName: e.target.value,
                  },
                })
              }
            />
            <FieldWithInput
              input={InputDate}
              inputProps={{
                value: incidentDate,
              }}
              label="Incident Date"
              onValidChange={(date) =>
                this.setState({
                  report: {
                    ...report,
                    incidentDate: date,
                  },
                })
              }
            />
          </Fields>
          <Fields>
            <FieldWithInput
              input={InputSelect}
              inputProps={{
                entity: 'hazard',
                options: inputOptions.REPORT_INCIDENT_HAZARDS,
                value: hazardPrimary,
              }}
              label="Primary Hazard"
              onValidChange={(e) =>
                this.setState({
                  report: {
                    ...report,
                    hazardPrimary: e.target.value,
                  },
                })
              }
            />
            <FieldWithInput
              input={InputSelect}
              inputProps={{
                entity: 'hazard',
                options: inputOptions.REPORT_INCIDENT_HAZARDS,
                value: hazardSecondary,
              }}
              label="Secondary Hazard"
              onValidChange={(e) =>
                this.setState({
                  report: {
                    ...report,
                    hazardSecondary: e.target.value,
                  },
                })
              }
            />
          </Fields>
        </Fieldset>
        <Buttons className="uk-margin-large-top">
          <Button type="submit" level="primary" onClick={this.handleSubmit}>
            Save
          </Button>
          <Button type="submit" level="primary" onClick={this.handleSubmitOverview}>
            <span className="uk-flex uk-flex-between uk-flex-middle">
              Area
              <Icon name="chevron-right" />
            </span>
          </Button>
        </Buttons>
      </Fieldset>
    )
  }

  renderAreas() {
    const { areas } = this.state.report

    return (
      <section>
        <Heading>Areas</Heading>
        {isEmpty(areas) ? (
          <React.Fragment>
            No areas
            <div className="uk-margin-top">
              <Button onClick={this.handleArea}>Add New Area</Button>
            </div>
          </React.Fragment>
        ) : (
          <div uk-grid="true" className="uk-margin uk-child-width-1-2 uk-child-width-1-3@s uk-grid">
            {Object.keys(areas).map((areaId) => (
              <a
                href="#"
                key={areaId}
                className="uk-grid-margin"
                onClick={() => this.handleArea(areaId)}>
                <Image
                  src={areas[areaId].imageUrl}
                  background
                  className={styles['objects--grid--item--img']}
                />
              </a>
            ))}
          </div>
        )}
      </section>
    )
  }

  renderArea() {
    const { area, report } = this.state
    const {
      address: areaAddress = '',
      conditionNumber: areaConditionNumber = '',
      country: areaCountry = '',
      hazards: areaHazards = '',
      id: areaId,
      imageRef: areaImageRef = '',
      imageUrl: areaImageUrl = '',
      images: areaImages = {},
      interventionRecommended: areaInterventionRecommended = '',
      inventoryNumber: areaInventoryNumber = '',
      lat: areaLat = '',
      lon: areaLon = '',
      name: areaName = '',
      notes: areaNotes = '',
      safetyPersonalHazard: areaSafetyPersonalHazard = '',
      state: areaState = '',
    } = area
    const { areas = {}, unassessedItems = {} } = report

    const areaUnassessedItems = pickBy(unassessedItems, { category: 'Area' })
    const unknownUnassessedItems = pickBy(unassessedItems, { category: 'Unknown' })

    //const isValid = areaName

    return (
      <Fieldset>
        <Heading>Area</Heading>
        {/*
        {areaImageUrl &&
          <Field>
            <Image src={areaImageUrl} background full className={styles.img} />
          </Field>
        }
        */}
        <FieldWithInput
          input={Input}
          inputProps={{
            value: areaName,
          }}
          label="Area Name"
          validate={(e) => assertions.required(e.target.value)}
          onValidChange={(e) =>
            this.setState({
              area: {
                ...area,
                name: e.target.value,
              },
            })
          }
        />
        {(!isEmpty(areaImages) || !isEmpty(areaUnassessedItems) || !isEmpty(unknownUnassessedItems)) &&
          <Field>
            <Label>Images</Label>
            <ThumbnailsMultipleSelectable
              active={areaImages}
              thumbnails={{
                ...areaImages,
                ...areaUnassessedItems,
                ...unknownUnassessedItems,
              }}
              onThumbnailSelect={(images) => {
                const otherUnassessedItems = omit(unassessedItems, Object.keys(images))

                // // if no images, add unassessed object data
                // const areaData = isEmpty(areaImages) ?
                //   { ...unassessedItems[Object.keys(images)[0]] } : {}

                // this.setState({
                //   area: {
                //     ...area,
                //     ...areaData,
                //     images: { ...images },
                //   },
                //   report: {
                //     ...report,
                //     unassessedItems: { ...otherUnassessedItems },
                //   },
                // })

                // don't overwrite new item id with previously unassessed item id
                const unassessedItemData = omit(unassessedItems[Object.keys(images)[0]], 'id')

                // if no images, add unassessed object data
                const areaData = isEmpty(areaImages) ?
                  { ...unassessedItemData } : {}

                this.setState({
                  area: {
                    ...area,
                    ...areaData,
                    images: { ...images },
                  },
                  // if selected unassessed item as image,
                  // used to remove from unassessedItems on submit
                  unassessedItems: { ...otherUnassessedItems },
                })
              }}
            />
          </Field>
        }
        <FieldWithAddress
          label="Location"
          addressComponents={{
            address: areaAddress,
            lat: areaLat,
            lon: areaLon,
            state: areaState,
            country: areaCountry,
          }}
          onChange={(address, lat, lon, state, country) =>
            this.setState({
              area: {
                ...area,
                address,
                country,
                lat,
                lon,
                state,
              },
            })
          }
        />
        <Fieldset>
          <FieldWithInputRadios
            title="Overall Condition"
            checked={areaConditionNumber}
            inputs={inputOptions.OBJECT_CONDITIONS}
            name="condition"
            onChange={(e) =>
              this.setState({
                area: {
                  ...area,
                  conditionNumber: e.target.value,
                },
              })
            }
          />
        </Fieldset>
        <Fieldset title="Assess">
          <FieldWithInput
            label="Hazards"
            input={InputCheckbox}
            inputProps={{
              value: areaHazards,
            }}
            onValidChange={(e) =>
              this.setState({
                area: {
                  ...area,
                  hazards: e.target.value,
                },
              })
            }
          />
          <FieldWithInput
            label="Safety/Personal Hazard"
            input={InputCheckbox}
            inputProps={{
              value: areaSafetyPersonalHazard,
            }}
            onValidChange={(e) =>
              this.setState({
                area: {
                  ...area,
                  safetyPersonalHazard: e.target.value,
                },
              })
            }
          />
          <FieldWithInput
            label="Intervention Recommended"
            input={InputCheckbox}
            inputProps={{
              value: areaInterventionRecommended,
            }}
            onValidChange={(e) =>
              this.setState({
                area: {
                  ...area,
                  interventionRecommended: e.target.value,
                },
              })
            }
          />
        </Fieldset>
        <Fieldset>
          <FieldWithInput
            input={Input}
            inputProps={{
              value: areaInventoryNumber,
            }}
            label="Existing Inventory Number"
            onValidChange={(e) =>
              this.setState({
                area: {
                  ...area,
                  inventoryNumber: e.target.value,
                },
              })
            }
          />
        </Fieldset>
        <Fieldset>
          <FieldWithInput
            label="Notes"
            input={Input}
            inputProps={{
              type: 'textarea',
              value: areaNotes,
            }}
            onValidChange={(e) =>
              this.setState({
                area: {
                  ...area,
                  notes: e.target.value,
                },
              })
            }
          />
        </Fieldset>
        {areas[areaId] &&
          <Fieldset>
            <Button className="uk-button-danger uk-button-small" onClick={this.handleDeleteArea}>
              Delete Area
            </Button>
          </Fieldset>
        }
        <Buttons className="uk-margin-large-top">
          <Button
            type="submit"
            //disabled={!isValid}
            level="primary"
            onClick={() => this.handleSubmitArea('save')}>
            Save
          </Button>
          <Button
            //disabled={!isValid}
            level="primary"
            onClick={this.handleBackFromArea}>
            <span className="uk-flex uk-flex-between uk-flex-middle">
              <Icon name="chevron-left" />
              Overview
            </span>
          </Button>
          <Button
            //disabled={!isValid}
            type="submit"
            level="primary"
            onClick={this.handleSubmitArea}>
            <span className="uk-flex uk-flex-between uk-flex-middle">
              Sites / Buildings
              <Icon name="chevron-right" />
            </span>
          </Button>
        </Buttons>
      </Fieldset>
    )
  }

  renderSites() {
    const { sites } = this.state.report

    return (
      <section>
        <Heading>Sites / Buildings</Heading>
        {isEmpty(sites) ? (
          <React.Fragment>
            No sites / buildings
            <div className="uk-margin-top">
              <Button onClick={this.handleSite}>Add/Update New Site / Building</Button>
            </div>
          </React.Fragment>
        ) : (
          <div uk-grid="true" className="uk-margin uk-child-width-1-2 uk-child-width-1-3@s uk-grid">
            {Object.keys(sites).map((siteId) => (
              <a
                href="#"
                key={siteId}
                className="uk-grid-margin"
                onClick={() => this.handleSite(siteId)}>
                <Image
                  src={sites[siteId].imageUrl}
                  background
                  className={styles['objects--grid--item--img']}
                />
              </a>
            ))}
          </div>
        )}
      </section>
    )
  }

  renderSiteComponent() {
    const {
      report,
      //siteComponent,
      siteComponent = {},
    } = this.state
    const { siteComponents, sites, unassessedItems } = report
    const {
      buttressDamage: siteComponentButtressDamage = '',
      construction: siteComponentConstruction = '',
      damage: siteComponentDamage = '',
      floorCount: siteComponentFloorCount = '',
      foundationFloorDamage: siteComponentFoundationFloorDamage = '',
      horizontalStructuralDamage: siteComponentHorizontalStructuralDamage = '',
      images: siteComponentImages = {},
      name: siteComponentName = '',
      roof: siteComponentRoof = '',
      roofDamage: siteComponentRoofDamage = '',
      roofDamagePercent: siteComponentRoofDamagePercent = '',
      structuralElement: siteComponentStructuralElement = '',
      subSurfaceDamage: siteComponentSubSurfaceDamage = '',
      surfaceDamage: siteComponentSurfaceDamage = '',
      verticalStructuralDamage: siteComponentVerticalStructuralDamage = '',
      windowsDoorsDamage: siteComponentWindowsDoorsDamage = '',
    } = siteComponent

    const siteComponentUnassessedItems = pickBy(unassessedItems, { category: 'Site Component' })
    const unknownUnassessedItems = pickBy(unassessedItems, { category: 'Unknown' })

    return (
      <Fieldset>
        <Heading>Site / Building Component</Heading>
        <FieldWithInput
          input={Input}
          inputProps={{
            value: siteComponentName,
          }}
          label="Site / Building Component Name"
          validate={(e) => assertions.required(e.target.value)}
          onValidChange={(e) =>
            this.setState({
              siteComponent: {
                ...siteComponent,
                name: e.target.value,
              },
            })
          }
        />

        {(!isEmpty(siteComponentImages) || !isEmpty(siteComponentUnassessedItems) || !isEmpty(siteComponents) || !isEmpty(unknownUnassessedItems)) &&
          <Field>
            <Label>Images</Label>
            <ThumbnailsMultipleSelectable
              active={siteComponentImages}
              thumbnails={{
                ...siteComponents, // unattached site components
                ...siteComponentImages,
                ...siteComponentUnassessedItems,
                ...unknownUnassessedItems,
              }}
              onThumbnailSelect={(images) => {
                const otherUnassessedItems = omit(unassessedItems, Object.keys(images))
                // don't overwrite new item id with previously unassessed item id
                const unassessedItemData = omit(unassessedItems[Object.keys(images)[0]], 'id')

                // if no images, add unassessed object data
                // const siteComponentData = isEmpty(siteComponentImages) ?
                //   { ...unassessedItemData } : {}

                //this.setState({
                //  report: {
                //    ...report,
                //    unassessedItems: { ...otherUnassessedItems },
                //  },
                //  site: {
                //    ...site,
                //    ...siteData,
                //    images: { ...images },
                //  },
                //})

                this.setState({
                  siteComponent: {
                    ...siteComponent,
                    //...siteComponentData,
                    images: { ...images },
                  },
                  unassessedItems: { ...otherUnassessedItems },
                })
              }}
            />
          </Field>
        }

        <FieldWithInput
          input={InputSelect}
          inputProps={{
            entity: 'number of floors',
            options: inputOptions.SITE_COMPONENT_FLOOR_COUNTS,
            value: siteComponentFloorCount,
          }}
          label="Total Floors of Building"
          onValidChange={(e) =>
            this.setState({
              siteComponent: {
                ...siteComponent,
                floorCount: e.target.value,
              },
            })
          }
        />
        <FieldWithInput
          input={InputSelect}
          inputProps={{
            entity: 'type of construction',
            options: inputOptions.SITE_COMPONENT_CONSTRUCTION_TYPES,
            value: siteComponentConstruction,
          }}
          label="Type of Construction"
          onValidChange={(e) =>
            this.setState({
              siteComponent: {
                ...siteComponent,
                construction: e.target.value,
              },
            })
          }
        />
        <Fields>
          <FieldWithInput
            input={InputSelect}
            inputProps={{
              entity: 'type of roof',
              options: inputOptions.SITE_COMPONENT_ROOF_TYPES,
              value: siteComponentRoof,
            }}
            label="Type of Roof"
            onValidChange={(e) =>
              this.setState({
                siteComponent: {
                  ...siteComponent,
                  roof: e.target.value,
                },
              })
            }
          />
          <FieldWithInput
            input={InputSelect}
            inputProps={{
              entity: 'type of roof damage',
              options: inputOptions.SITE_COMPONENT_ROOF_DAMAGE_TYPES,
              value: siteComponentRoofDamage,
            }}
            label="Type of Roof Damage"
            onValidChange={(e) =>
              this.setState({
                siteComponent: {
                  ...siteComponent,
                  roofDamage: e.target.value,
                },
              })
            }
          />
        </Fields>
        <Fields>
          <FieldWithInput
            input={InputSelect}
            inputProps={{
              entity: 'type of damage',
              options: inputOptions.SITE_COMPONENT_VERTICAL_STRUCTURAL_DAMAGE_TYPES,
              value: siteComponentVerticalStructuralDamage,
            }}
            label="Type of Damage of Wall/Columns/Vertical Structural Elements"
            onValidChange={(e) =>
              this.setState({
                siteComponent: {
                  ...siteComponent,
                  verticalStructuralDamage: e.target.value,
                },
              })
            }
          />
          <FieldWithInput
            input={InputSelect}
            inputProps={{
              entity: 'type of damage',
              options: inputOptions.SITE_COMPONENT_HORIZONTAL_STRUCTURAL_DAMAGE_TYPES,
              value: siteComponentHorizontalStructuralDamage,
            }}
            label="Type of Damage of Beams/Arches/Horizontal Structural Elements"
            onValidChange={(e) =>
              this.setState({
                siteComponent: {
                  ...siteComponent,
                  horizontalStructuralDamage: e.target.value,
                },
              })
            }
          />
        </Fields>
        <FieldWithInput
          input={InputSelect}
          inputProps={{
            entity: 'type of damage',
            options: inputOptions.SITE_COMPONENT_FLOOR_FOUNDATION_DAMAGE_TYPES,
            value: siteComponentFoundationFloorDamage,
          }}
          label="Type of Damage of Foundation/Floor"
          onValidChange={(e) =>
            this.setState({
              siteComponent: {
                ...siteComponent,
                foundationFloorDamage: e.target.value,
              },
            })
          }
        />
        <FieldWithInput
          input={InputSelect}
          inputProps={{
            entity: 'type of damage',
            options: inputOptions.SITE_COMPONENT_BUTTRESS_DAMAGE_TYPES,
            value: siteComponentButtressDamage,
          }}
          label="Type of Damage of Buttress"
          onValidChange={(e) =>
            this.setState({
              siteComponent: {
                ...siteComponent,
                buttressDamage: e.target.value,
              },
            })
          }
        />
        <FieldWithInput
          input={InputSelect}
          inputProps={{
            entity: 'type of damage',
            options: inputOptions.SITE_COMPONENT_WINDOWS_DOORS_DAMAGE_TYPES,
            value: siteComponentWindowsDoorsDamage,
          }}
          label="Type of Damage of Windows/Doors"
          onValidChange={(e) =>
            this.setState({
              siteComponent: {
                ...siteComponent,
                windowsDoorsDamage: e.target.value,
              },
            })
          }
        />
        <FieldWithInput
          input={InputSelect}
          inputProps={{
            entity: 'type of damage',
            options: inputOptions.SITE_COMPONENT_SUB_SURFACE_DAMAGE_TYPES,
            value: siteComponentSubSurfaceDamage,
          }}
          label="Type of Damage of Archaeological Strata/Sub Surface Materials"
          onValidChange={(e) =>
            this.setState({
              siteComponent: {
                ...siteComponent,
                subSurfaceDamage: e.target.value,
              },
            })
          }
        />
        <FieldWithInput
          input={InputSelect}
          inputProps={{
            entity: 'type of damage',
            options: inputOptions.SITE_COMPONENT_SURFACE_DAMAGE_TYPES,
            value: siteComponentSurfaceDamage,
          }}
          label="Type of Damage of Facade/Surface"
          onValidChange={(e) =>
            this.setState({
              siteComponent: {
                ...siteComponent,
                surfaceDamage: e.target.value,
              },
            })
          }
        />
        <FieldWithInput
          input={InputSelect}
          inputProps={{
            entity: 'structural element',
            options: inputOptions.SITE_COMPONENT_STRUCTURAL_ELEMENTS,
            value: siteComponentStructuralElement,
          }}
          label="Other Structural Element"
          onValidChange={(e) =>
            this.setState({
              siteComponent: {
                ...siteComponent,
                structuralElement: e.target.value,
              },
            })
          }
        />
        <FieldWithInput
          input={InputSelect}
          inputProps={{
            entity: 'percent damage',
            options: inputOptions.SITE_COMPONENT_DAMAGES,
            value: siteComponentDamage,
          }}
          label="Percent Damaged (Of Each Component)"
          onValidChange={(e) =>
            this.setState({
              siteComponent: {
                ...siteComponent,
                damage: e.target.value,
              },
            })
          }
        />
        {siteComponent.id &&
          <Fieldset>
            <Button
              className="uk-button-danger uk-button-small"
              onClick={this.handleDeleteSiteComponent}>
              Delete Building / Site Component
            </Button>
          </Fieldset>
        }
        <Buttons className="uk-margin-large-top">
          <Button type="submit" level="primary" onClick={this.handleSubmitSiteComponent}>
            Save
          </Button>
        </Buttons>
      </Fieldset>
    )
  }

  renderSite() {
    const { report, site } = this.state
    const { areas = {}, sites = {}, unassessedItems = {} } = report
    const {
      address: siteAddress = '',
      architecturalStyle: siteArchitecturalStyle = '',
      area: siteArea = '',
      conditionNumber: siteConditionNumber = '',
      country: siteCountry = '',
      hazards: siteHazards = '',
      id: siteId,
      imageRef: siteImageRef = '',
      imageUrl: siteImageUrl = '',
      images: siteImages = {},
      interventionDescription: siteInterventionDescription = '',
      interventionRequired: siteInterventionRequired = '',
      interventionType: siteInterventionType = '',
      inventoryNumber: siteInventoryNumber = '',
      lat: siteLat = '',
      lon: siteLon = '',
      name: siteName = '',
      notes: siteNotes = '',
      ownershipControl: siteOwnershipControl = '',
      personalSafetyHazards: sitePersonalSafetyHazards = '',
      protection: siteProtection = '',
      state: siteState = '',
      use: siteUse = '',
    } = site

    const siteUnassessedItems = pickBy(unassessedItems, { category: 'Site' })
    const unknownUnassessedItems = pickBy(unassessedItems, { category: 'Unknown' })

    //const isValid = siteName

    const areasFiltered = Object.keys(areas).filter((areaId) => areas[areaId].name)
    const areaOptions = []

    // eslint-disable-next-line array-callback-return
    areasFiltered.map((areaId) => {
      areaOptions.push({
        option: areas[areaId].name,
        value: areaId,
      })
    })

    return (
      <Fieldset>
        <Heading>Site / Building</Heading>
        {/*
        {siteImageUrl &&
          <Field>
            <Image src={siteImageUrl} full />
          </Field>
        }
        */}
        <FieldWithInput
          input={Input}
          inputProps={{
            value: siteName,
          }}
          label="Site / Building Name"
          validate={(e) => assertions.required(e.target.value)}
          onValidChange={(e) =>
            this.setState({
              site: {
                ...site,
                name: e.target.value,
              },
            })
          }
        />
        {!isEmpty(areasFiltered) &&
          <FieldWithInput
            input={InputSelect}
            inputProps={{
              entity: 'area',
              options: areaOptions,
              value: siteArea,
            }}
            label="Area"
            onValidChange={(e) =>
              this.setState({
                site: {
                  ...site,
                  area: e.target.value,
                },
              })
            }
          />
        }
        {(!isEmpty(siteImages) || !isEmpty(siteUnassessedItems) || !isEmpty(unknownUnassessedItems)) &&
          <Field>
            <Label>Images</Label>
            <ThumbnailsMultipleSelectable
              active={siteImages}
              thumbnails={{
                ...siteImages,
                ...siteUnassessedItems,
                ...unknownUnassessedItems,
              }}
              onThumbnailSelect={(images) => {
                const otherUnassessedItems = omit(unassessedItems, Object.keys(images))
                // don't overwrite new item id with previously unassessed item id
                const unassessedItemData = omit(unassessedItems[Object.keys(images)[0]], 'id')

                // if no images, add unassessed object data
                const siteData = isEmpty(siteImages) ?
                  { ...unassessedItemData } : {}

                //this.setState({
                //  report: {
                //    ...report,
                //    unassessedItems: { ...otherUnassessedItems },
                //  },
                //  site: {
                //    ...site,
                //    ...siteData,
                //    images: { ...images },
                //  },
                //})

                this.setState({
                  site: {
                    ...site,
                    ...siteData,
                    images: { ...images },
                  },
                  unassessedItems: { ...otherUnassessedItems },
                })
              }}
            />
          </Field>
        }
        <FieldWithAddress
          label="Location"
          addressComponents={{
            address: siteAddress,
            lat: siteLat,
            lon: siteLon,
            state: siteState,
            country: siteCountry,
          }}
          onChange={(address, lat, lon, state, country) =>
            this.setState({
              site: {
                ...site,
                address,
                country,
                lat,
                lon,
                state,
              },
            })
          }
        />
        <Fieldset>
          <FieldWithInputRadios
            title="Overall Condition"
            checked={siteConditionNumber}
            inputs={inputOptions.SITE_CONDITIONS}
            name="condition"
            onChange={(e) =>
              this.setState({
                site: {
                  ...site,
                  conditionNumber: e.target.value,
                },
              })
            }
          />
        </Fieldset>
        <Fieldset title="Assess">
          <FieldWithInput
            label="Hazards"
            input={InputCheckbox}
            inputProps={{
              value: siteHazards,
            }}
            onValidChange={(e) =>
              this.setState({
                site: {
                  ...site,
                  hazards: e.target.value,
                },
              })
            }
          />
        </Fieldset>
        <Fieldset>
          <FieldWithInput
            input={Input}
            inputProps={{
              value: siteInventoryNumber,
            }}
            label="Existing Inventory Number"
            onValidChange={(e) =>
              this.setState({
                site: {
                  ...site,
                  inventoryNumber: e.target.value,
                },
              })
            }
          />
          <Fields>
            <FieldWithInput
              input={InputSelect}
              inputProps={{
                entity: 'use',
                options: inputOptions.SITE_USES,
                value: siteUse,
              }}
              label="Use"
              onValidChange={(e) =>
                this.setState({
                  site: {
                    ...site,
                    use: e.target.value,
                  },
                })
              }
            />
            <FieldWithInput
              input={InputSelect}
              inputProps={{
                entity: 'ownership/control',
                options: inputOptions.SITE_OWNERSHIPS_CONTROLS,
                value: siteOwnershipControl,
              }}
              label="Ownership / Control"
              onValidChange={(e) =>
                this.setState({
                  site: {
                    ...site,
                    ownershipControl: e.target.value,
                  },
                })
              }
            />
          </Fields>
          <Fields>
            <FieldWithInput
              input={InputSelect}
              inputProps={{
                entity: 'level',
                options: inputOptions.SITE_PROTECTION_LEVELS,
                value: siteProtection,
              }}
              label="Level of Protection"
              onValidChange={(e) =>
                this.setState({
                  site: {
                    ...site,
                    protection: e.target.value,
                  },
                })
              }
            />
            <FieldWithInput
              input={InputSelect}
              inputProps={{
                entity: 'style',
                options: inputOptions.SITE_ARCHITECTURAL_STYLES,
                value: siteArchitecturalStyle,
              }}
              label="Architectural Style"
              onValidChange={(e) =>
                this.setState({
                  site: {
                    ...site,
                    architecturalStyle: e.target.value,
                  },
                })
              }
            />
          </Fields>
        </Fieldset>
        <FieldWithInputCheckboxes
          title="Personal Safety Hazards"
          inputs={inputOptions.SITE_PERSONAL_SAFETY_HAZARDS}
          onChange={(value) =>
            this.setState({
              site: {
                ...site,
                personalSafetyHazards: value,
              },
            })
          }
        />
        <Fieldset title="Intervention">
          <Fields>
            <FieldWithInputRadios
              title="Intervention required?"
              checked={siteInterventionRequired}
              inputs={inputOptions.SITE_INTERVENTION_REQUIREMENTS}
              name="intervention-required"
              onChange={(e) =>
                this.setState({
                  site: {
                    ...site,
                    interventionRequired: e.target.value,
                  },
                })
              }
            />
            <FieldWithInput
              input={InputSelect}
              inputProps={{
                entity: 'intervention',
                options: inputOptions.SITE_INTERVENTION_TYPES,
                value: siteInterventionType,
              }}
              label="Type of Intervention"
              onValidChange={(e) =>
                this.setState({
                  site: {
                    ...site,
                    interventionType: e.target.value,
                  },
                })
              }
            />
          </Fields>
          <FieldWithInput
            input={Input}
            inputProps={{
              type: 'textarea',
              //value: siteInterventionDescription,
              children: siteInterventionDescription,
            }}
            label="Description"
            onValidChange={(e) =>
              this.setState({
                site: {
                  ...site,
                  interventionDescription: e.target.value,
                },
              })
            }
          />
        </Fieldset>
        <Fieldset>
          <FieldWithInput
            label="Notes"
            input={Input}
            inputProps={{
              type: 'textarea',
              value: siteNotes,
            }}
            onValidChange={(e) =>
              this.setState({
                site: {
                  ...site,
                  notes: e.target.value,
                },
              })
            }
          />
        </Fieldset>
        {sites[siteId] &&
          <Fieldset>
            <Button className="uk-button-danger uk-button-small" onClick={this.handleDeleteSite}>
              Delete Site / Building
            </Button>
          </Fieldset>
        }
        <Buttons className="uk-margin-large-top">
          <Button
            type="submit"
            //disabled={!isValid}
            level="primary"
            onClick={() => this.handleSubmitSite('save')}>
            Save
          </Button>
          <Button
            //disabled={!isValid}
            level="primary"
            onClick={this.handleBackFromSite}>
            <span className="uk-flex uk-flex-between uk-flex-middle">
              <Icon name="chevron-left" />
              Areas
            </span>
          </Button>
          <Button
            //disabled={!isValid}
            level="primary"
            onClick={this.handleSubmitSite}>
            <span className="uk-flex uk-flex-between uk-flex-middle">
              Collections / Objects
              <Icon name="chevron-right" />
            </span>
          </Button>
        </Buttons>
      </Fieldset>
    )
  }

  renderObjects() {
    const { objects } = this.state.report

    return (
      <section>
        <Heading>Collections / Objects</Heading>
        {isEmpty(objects) ?
          'No collections / objects' :
          (
            <div uk-grid="true" className="uk-margin uk-child-width-1-2 uk-child-width-1-3@s uk-grid">
              {Object.keys(objects).map((objectId) => (
                <a
                  href="#"
                  key={objectId}
                  className="uk-grid-margin"
                  onClick={() => this.handleUnassessedItem(objectId)}>
                  <Image
                    src={objects[objectId].imageUrl}
                    background
                    className={styles['objects--grid--item--img']}
                  />
                </a>
              ))}
            </div>
          )
        }
      </section>
    )
  }

  renderObject() {
    const { object, report } = this.state
    const {
      conditionNumber: objectConditionNumber = '',
      count: objectCount = '',
      damagePercentage: objectDamagePercentage = '',
      damageSignificance: objectDamageSignificance = '',
      damageSource: objectDamageSource = '',
      damageType: objectDamageType = '',
      dimensions: objectDimensions = '',
      floorNumber: objectFloorNumber = '',
      hazards: objectHazards = '',
      id: objectId,
      imageRef: objectImageRef = '',
      imageUrl: objectImageUrl = '',
      images: objectImages = {},
      interventionRecommended: objectInterventionRecommended = '',
      inventoryNumber: objectInventoryNumber = '',
      location: objectLocation = '',
      locationDetails: objectLocationDetails = '',
      locationType: objectLocationType = '',
      materialInorganic: objectMaterialInorganic = '',
      materialOrganic: objectMaterialOrganic = '',
      name: objectName = '',
      notes: objectNotes = '',
      previousRecords: objectPreviousRecords = '',
      records: objectRecords = '',
      recordsDetails: objectRecordsDetails = '',
      roomFunction: objectRoomFunction = '',
      roomNumber: objectRoomNumber = '',
      safetyPersonalHazard: objectSafetyPersonalHazard = '',
      site: objectSite = '',
      type: objectType = '',
    } = object
    const { objects = {}, sites = {}, unassessedItems = {} } = report

    const objectUnassessedItems = pickBy(unassessedItems, { category: 'Object' })
    const unknownUnassessedItems = pickBy(unassessedItems, { category: 'Unknown' })

    //const isValid = !isEmpty(objectImages) && objectName
    //const isValid = objectName

    const sitesFiltered = Object.keys(sites).filter((siteId) => sites[siteId].name)
    const siteOptions = []

    // eslint-disable-next-line array-callback-return
    sitesFiltered.map((siteId) => {
      siteOptions.push({
        option: sites[siteId].name,
        value: siteId,
      })
    })

    return (
      <Fieldset>
        <Heading>Collection / Object</Heading>
        {/*
        {objectImageUrl &&
          <Field>
            <Image src={objectImageUrl} full />
          </Field>
        }
        */}
        <FieldWithInput
          input={Input}
          inputProps={{
            value: objectName,
          }}
          label="Name"
          onValidChange={(e) =>
            this.setState({
              object: {
                ...object,
                name: e.target.value,
              },
            })
          }
        />
        {!isEmpty(sitesFiltered) &&
          <FieldWithInput
            input={InputSelect}
            inputProps={{
              entity: 'building / site',
              options: siteOptions,
              value: objectSite,
            }}
            label="Buiding / Site"
            onValidChange={(e) =>
              this.setState({
                object: {
                  ...object,
                  site: e.target.value,
                },
              })
            }
          />
        }
        {(!isEmpty(objectImages) || !isEmpty(objectUnassessedItems) || !isEmpty(unknownUnassessedItems)) &&
          <Field>
            <Label>Images</Label>
            <ThumbnailsMultipleSelectable
              active={objectImages}
              thumbnails={{
                ...objectImages,
                ...objectUnassessedItems,
                ...unknownUnassessedItems,
              }}
              onThumbnailSelect={(images) => {
                const otherUnassessedItems = omit(unassessedItems, Object.keys(images))
                // don't overwrite new item id with previously unassessed item id
                const unassessedItemData = omit(unassessedItems[Object.keys(images)[0]], 'id')

                // if no images, add unassessed object data
                const objectData = isEmpty(objectImages) ?
                  { ...unassessedItemData } : {}

                this.setState({
                  object: {
                    ...object,
                    ...objectData,
                    images: { ...images },
                  },
                  //report: {
                  //  ...report,
                  //  unassessedItems: { ...otherUnassessedItems },
                  //},

                  // if selected unassessed item as image,
                  // used to remove from unassessedItems on submit
                  unassessedItems: { ...otherUnassessedItems },
                })
              }}
            />
          </Field>
        }
        <Fieldset>
          <FieldWithInputRadios
            title="Overall Condition"
            checked={objectConditionNumber}
            inputs={inputOptions.OBJECT_CONDITIONS}
            name="condition"
            onChange={(e) =>
              this.setState({
                object: {
                  ...object,
                  conditionNumber: e.target.value,
                },
              })
            }
          />
        </Fieldset>
        <Fieldset title="Assess">
          <FieldWithInput
            label="Hazards"
            input={InputCheckbox}
            inputProps={{
              value: objectHazards,
            }}
            onValidChange={(e) =>
              this.setState({
                object: {
                  ...object,
                  hazards: e.target.value,
                },
              })
            }
          />
          <FieldWithInput
            label="Safety/Personal Hazard"
            input={InputCheckbox}
            inputProps={{
              value: objectSafetyPersonalHazard,
            }}
            onValidChange={(e) =>
              this.setState({
                object: {
                  ...object,
                  safetyPersonalHazard: e.target.value,
                },
              })
            }
          />
          <FieldWithInput
            label="Intervention Recommended"
            input={InputCheckbox}
            inputProps={{
              value: objectInterventionRecommended,
            }}
            onValidChange={(e) =>
              this.setState({
                object: {
                  ...object,
                  interventionRecommended: e.target.value,
                },
              })
            }
          />
        </Fieldset>
        <Fieldset>
          <Fields>
            <FieldWithInputRadios
              title="Are the objects in their original or pre-event location?"
              checked={objectLocation}
              inputs={inputOptions.OBJECT_LOCATIONS}
              name="location"
              onChange={(e) =>
                this.setState({
                  object: {
                    ...object,
                    location: e.target.value,
                  },
                })
              }
            />
            <FieldWithInput
              input={InputSelect}
              inputProps={{
                entity: 'location',
                options: inputOptions.OBJECT_LOCATION_TYPES,
                value: objectLocationType,
              }}
              label="Location of Collections / Objects?"
              onValidChange={(e) =>
                this.setState({
                  object: {
                    ...object,
                    locationType: e.target.value,
                  },
                })
              }
            />
          </Fields>
          <FieldWithInput
            input={Input}
            inputProps={{
              value: objectInventoryNumber,
            }}
            label="Existing Inventory Number"
            onValidChange={(e) =>
              this.setState({
                object: {
                  ...object,
                  inventoryNumber: e.target.value,
                },
              })
            }
          />
          <Fields>
            <FieldWithInput
              input={Input}
              inputProps={{
                type: 'number',
                value: objectFloorNumber,
              }}
              label="Floor Number"
              onValidChange={(e) =>
                this.setState({
                  object: {
                    ...object,
                    floorNumber: e.target.value,
                  },
                })
              }
            />
            <FieldWithInput
              input={Input}
              inputProps={{
                type: 'number',
                value: objectRoomNumber,
              }}
              label="Room Number"
              onValidChange={(e) =>
                this.setState({
                  object: {
                    ...object,
                    roomNumber: e.target.value,
                  },
                })
              }
            />
          </Fields>
          <Fields>
            <FieldWithInputRadios
              title="Do previous records exist?"
              checked={objectRecords}
              inputs={inputOptions.OBJECT_RECORDS}
              name="records"
              onChange={(e) =>
                this.setState({
                  object: {
                    ...object,
                    records: e.target.value,
                  },
                })
              }
            />
            <FieldWithInput
              input={Input}
              inputProps={{
                type: 'textarea',
                //value: objectRecordsDetails,
                children: objectRecordsDetails,
              }}
              label="If yes, where are they located / who has them? Explain"
              onValidChange={(e) =>
                this.setState({
                  object: {
                    ...object,
                    recordsDetails: e.target.value,
                  },
                })
              }
            />
          </Fields>
          <FieldWithInput
            input={InputSelect}
            inputProps={{
              entity: 'damage significance',
              options: inputOptions.OBJECT_DAMAGE_SIGNIFICANCES,
              value: objectDamageSignificance,
            }}
            label="Does the previous documentation indicate the significance of the damaged objects?"
            onValidChange={(e) =>
              this.setState({
                object: {
                  ...object,
                  damageSignificance: e.target.value,
                },
              })
            }
          />
          <FieldWithInput
            input={InputSelect}
            inputProps={{
              entity: 'function',
              options: inputOptions.OBJECT_ROOM_FUNCTIONS,
              value: objectRoomFunction,
            }}
            label="Function of Room Before Event"
            onValidChange={(e) =>
              this.setState({
                object: {
                  ...object,
                  roomFunction: e.target.value,
                },
              })
            }
          />
          <FieldWithInput
            input={InputSelect}
            inputProps={{
              entity: 'type',
              options: inputOptions.OBJECT_TYPES,
              value: objectType,
            }}
            label="Type of Collection / Object"
            onValidChange={(e) =>
              this.setState({
                object: {
                  ...object,
                  type: e.target.value,
                },
              })
            }
          />
          <Fields>
            <FieldWithInput
              input={InputSelect}
              inputProps={{
                entity: 'material',
                options: inputOptions.OBJECT_MATERIALS_ORGANIC,
                value: objectMaterialOrganic,
              }}
              label="Organic Materials"
              onValidChange={(e) =>
                this.setState({
                  object: {
                    ...object,
                    materialOrganic: e.target.value,
                  },
                })
              }
            />
            <FieldWithInput
              input={InputSelect}
              inputProps={{
                entity: 'material',
                options: inputOptions.OBJECT_MATERIALS_INORGANIC,
                value: objectMaterialInorganic,
              }}
              label="Inorganic Materials"
              onValidChange={(e) =>
                this.setState({
                  object: {
                    ...object,
                    materialInorganic: e.target.value,
                  },
                })
              }
            />
          </Fields>
          <Fields>
            <FieldWithInput
              input={InputSelect}
              inputProps={{
                entity: 'number',
                options: inputOptions.OBJECT_COUNTS,
                value: objectCount,
              }}
              label="Estimated Number of Objects"
              onValidChange={(e) =>
                this.setState({
                  object: {
                    ...object,
                    count: e.target.value,
                  },
                })
              }
            />
            <FieldWithInput
              input={Input}
              inputProps={{
                value: objectDimensions,
              }}
              label="If everything is in a pile: add dimensions of the pile (height, length, width)"
              onValidChange={(e) =>
                this.setState({
                  object: {
                    ...object,
                    dimensions: e.target.value,
                  },
                })
              }
            />
          </Fields>
          <Fields>
            <FieldWithInput
              input={InputSelect}
              inputProps={{
                entity: 'type',
                options: inputOptions.OBJECT_DAMAGE_SOURCES,
                value: objectDamageSource,
              }}
              label="Possible Sources of Damage"
              onValidChange={(e) =>
                this.setState({
                  object: {
                    ...object,
                    damageSource: e.target.value,
                  },
                })
              }
            />
            <FieldWithInput
              input={InputSelect}
              inputProps={{
                entity: 'type',
                options: inputOptions.OBJECT_DAMAGE_TYPES,
                value: objectDamageType,
              }}
              label="Type of Damage"
              onValidChange={(e) =>
                this.setState({
                  object: {
                    ...object,
                    damageType: e.target.value,
                  },
                })
              }
            />
          </Fields>
          <FieldWithInputRadios
            title="Overall Percent of Damage?"
            checked={objectDamagePercentage}
            inputs={inputOptions.OBJECT_DAMAGE_PERCENTAGES}
            name="damage-percentage"
            onChange={(e) =>
              this.setState({
                object: {
                  ...object,
                  damagePercentage: e.target.value,
                },
              })
            }
          />
        </Fieldset>
        <Fieldset>
          <FieldWithInput
            label="Notes"
            input={Input}
            inputProps={{
              type: 'textarea',
              value: objectNotes,
            }}
            onValidChange={(e) =>
              this.setState({
                object: {
                  ...object,
                  notes: e.target.value,
                },
              })
            }
          />
        </Fieldset>
        {objects[objectId] &&
          <Fieldset>
            <Button className="uk-button-danger uk-button-small" onClick={this.handleDeleteObject}>
              Delete Collection / Object
            </Button>
          </Fieldset>
        }
        <Buttons className="uk-margin-top">
          {/*
          <Button type="submit" disabled={!isValid} level="primary" onClick={() => this.handleSubmitObject('save')}>
            Save
          </Button>
          */}
          <Button
            //disabled={!isValid}
            onClick={this.handleSubmitObject}>
            {/*Update Collection / Object*/}
            Save
            {/*Collection / Object*/}
          </Button>
        </Buttons>
      </Fieldset>
    )
  }

  renderUnassessedItems() {
    const { unassessedItems } = this.state.report
    console.log('unassessedItems', unassessedItems)

    return (
      <section>
        <Heading>Assess</Heading>
        {isEmpty(unassessedItems) ?
          'No unassessed collections / objects' :
          (
            <div uk-grid="true" className="uk-margin uk-child-width-1-2 uk-child-width-1-3@s uk-grid">
              {Object.keys(unassessedItems).map((objectId) => (
                <a
                  href="#"
                  key={objectId}
                  className="uk-grid-margin"
                  onClick={() => this.handleUnassessedItem(objectId)}>
                  {/*
                  <Image
                    src={unassessedItems[objectId].imageUrl}
                    background
                    className={styles['objects--grid--item--img']}
                  />
                  */}
                  <FirebaseImage
                    imageRef={unassessedItems[objectId].imageRef}
                    background
                    thumbnail
                    thumbnailSize="512"
                    className={styles['objects--grid--item--img']}
                  />
                </a>
              ))}
            </div>
          )
        }
      </section>
    )
  }

  renderUnassessedItem() {
    const { report, unassessedItem } = this.state
    const { areas = {}, objects = {}, sites = {} } = report
    const {
      address: unassessedItemAddress = '',
      area: unassessedItemArea = '',
      category: unassessedItemCategory = '',
      conditionNumber: unassessedItemConditionNumber = '',
      country: unassessedItemCountry =  '',
      lat: unassessedItemLat,
      lon: unassessedItemLon,
      hazards: unassessedItemHazards = '',
      imageUrl: unassessedItemImageUrl,
      interventionRecommended: unassessedItemInterventionRecommended = '',
      name: unassessedItemName = '',
      notes: unassessedItemNotes = '',
      object: unassessedItemObject = '',
      safetyPersonalHazard: unassessedItemSafetyPersonalHazard = '',
      site: unassessedItemSite = '',
      state: unassessedItemState = '',
    } = unassessedItem

    //const isValid = (unassessedItemCategory === 'Unknown') ? true : unassessedItemName

    const areasFiltered = Object.keys(areas).filter((areaId) => areas[areaId].name)
    const areaOptions = []
    const sitesFiltered = Object.keys(sites).filter((siteId) => sites[siteId].name)
    const siteOptions = []
    const objectsFiltered = Object.keys(objects).filter((objectId) => objects[objectId].name)
    const objectOptions = []

    // eslint-disable-next-line array-callback-return
    areasFiltered.map((areaId) => {
      areaOptions.push({
        option: areas[areaId].name,
        value: areaId,
      })
    })

    // eslint-disable-next-line array-callback-return
    sitesFiltered.map((siteId) => {
      siteOptions.push({
        option: sites[siteId].name,
        value: siteId,
      })
    })

    // eslint-disable-next-line array-callback-return
    objectsFiltered.map((objectId) => {
      objectOptions.push({
        option: objects[objectId].name,
        value: objectId,
      })
    })

    return (
      <Fieldset>
        <Heading>Assess</Heading>
        {unassessedItemImageUrl &&
          <Field>
            <Image src={unassessedItemImageUrl} full />
          </Field>
        }
        <FieldWithInput
          input={Input}
          inputProps={{
            value: unassessedItemName,
          }}
          label="Name"
          onValidChange={(e) =>
            this.setState({
              unassessedItem: {
                ...unassessedItem,
                name: e.target.value,
              },
            })
          }
        />
        {(unassessedItemCategory === 'Site' || unassessedItemCategory === 'Unknown') && !isEmpty(areasFiltered) &&
          <FieldWithInput
            input={InputSelect}
            inputProps={{
              entity: 'area',
              options: areaOptions,
              value: unassessedItemArea,
            }}
            label="Area"
            onValidChange={(e) =>
              this.setState({
                unassessedItem: {
                  ...unassessedItem,
                  area: e.target.value,
                },
              })
            }
          />
        }
        {(unassessedItemCategory === 'Object' || unassessedItemCategory === 'Unknown') && !isEmpty(sitesFiltered) &&
          <FieldWithInput
            input={InputSelect}
            inputProps={{
              entity: 'building / site',
              options: siteOptions,
              value: unassessedItemSite,
            }}
            label="Site / Building"
            onValidChange={(e) =>
              this.setState({
                unassessedItem: {
                  ...unassessedItem,
                  site: e.target.value,
                },
              })
            }
          />
        }
        {unassessedItemCategory === 'Unknown' && !isEmpty(objectsFiltered) &&
          <FieldWithInput
            input={InputSelect}
            inputProps={{
              entity: 'object / collection',
              options: objectOptions,
              value: unassessedItemObject,
            }}
            label="Site / Building"
            onValidChange={(e) =>
              this.setState({
                unassessedItem: {
                  ...unassessedItem,
                  object: e.target.value,
                },
              })
            }
          />
        }
        <FieldWithAddress
          label="Location"
          addressComponents={{
            address: unassessedItemAddress,
            lat: unassessedItemLat,
            lon: unassessedItemLon,
            state: unassessedItemState,
            country: unassessedItemCountry,
          }}
          onChange={(address, lat, lon, state, country) =>
            this.setState({
              unassessedItem: {
                ...unassessedItem,
                address,
                country,
                lat,
                lon,
                state,
              },
            })
          }
        />
        <Fieldset>
          <Fields>
            <FieldWithInputRadios
              title="Category"
              checked={unassessedItemCategory}
              inputs={inputOptions.OBJECT_CATEGORIES}
              name="category"
              onChange={(e) =>
                this.setState({
                  unassessedItem: {
                    ...unassessedItem,
                    category: e.target.value,
                  },
                })
              }
            />
            <FieldWithInputRadios
              title="Overall Condition"
              checked={unassessedItemConditionNumber}
              inputs={inputOptions.OBJECT_CONDITIONS}
              name="condition"
              onChange={(e) =>
                this.setState({
                  unassessedItem: {
                    ...unassessedItem,
                    conditionNumber: e.target.value,
                  },
                })
              }
            />
          </Fields>
        </Fieldset>
        <Fieldset title="Assess">
          <FieldWithInput
            label="Hazards"
            input={InputCheckbox}
            inputProps={{
              value: unassessedItemHazards,
            }}
            onValidChange={(e) =>
              this.setState({
                unassessedItem: {
                  ...unassessedItem,
                  hazards: e.target.value,
                },
              })
            }
          />
          <FieldWithInput
            label="Safety/Personal Hazard"
            input={InputCheckbox}
            inputProps={{
              value: unassessedItemSafetyPersonalHazard,
            }}
            onValidChange={(e) =>
              this.setState({
                unassessedItem: {
                  ...unassessedItem,
                  safetyPersonalHazard: e.target.value,
                },
              })
            }
          />
          <FieldWithInput
            label="Intervention Recommended"
            input={InputCheckbox}
            inputProps={{
              value: unassessedItemInterventionRecommended,
            }}
            onValidChange={(e) =>
              this.setState({
                unassessedItem: {
                  ...unassessedItem,
                  interventionRecommended: e.target.value,
                },
              })
            }
          />
        </Fieldset>
        <Fieldset>
          <FieldWithInput
            label="Notes"
            input={Input}
            inputProps={{
              type: 'textarea',
              value: unassessedItemNotes,
            }}
            onValidChange={(e) =>
              this.setState({
                unassessedItem: {
                  ...unassessedItem,
                  notes: e.target.value,
                },
              })
            }
          />
        </Fieldset>
        <div className="uk-margin-top">
          <Button
            //disabled={!isValid}
            onClick={this.handleSubmitUnassessedItem}>
            {/*Assess*/}
            Save
          </Button>
        </div>
      </Fieldset>
    )
  }

  render() {
    const { report, visible } = this.state

    if (!report) return null

    const { areas = {}, objects = {}, sites = {}, unassessedItems = {} } = report

    return (
      <div className="Report">
        <Meta title="Report" />
        <div className="uk-container">
          <div className="uk-section uk-section-default">
            <div uk-grid="true" className="uk-grid uk-grid-margin">
              <div className="uk-width-expand@m uk-grid-item-match">
                <div className="uk-tile uk-tile-muted">
                  <ul className={`${styles.nav} uk-nav-default uk-nav-parent-icon`} uk-nav="true">
                    <li>
                      <a href="#" onClick={this.handleShowOverview}>Overview</a>
                    </li>
                    <li className="uk-parent">
                      <a
                        href="#"
                        //onClick={this.handleShowAreas}
                        >
                        Areas
                      </a>
                      <ul className="uk-nav-sub">
                        <li>
                          <a href="#" onClick={this.handleArea}>
                            <Icon name="plus" className="uk-margin-small-right" />
                            New Area
                          </a>
                        </li>
                        {Object.keys(areas).map((areaId) => (
                          <li key={areaId}>
                            <a
                              href="#"
                              className="uk-text-truncate"
                              onClick={() => this.handleArea(areaId)}>
                              {areas[areaId].name || 'Unnamed Area'}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </li>
                    <li className="uk-parent">
                      <a
                        href="#"
                        //onClick={this.handleShowSites}
                        >
                        Sites / Buildings
                      </a>
                      <ul className="uk-nav-sub">
                        <li>
                          <a href="#" onClick={this.handleSite}>
                            <Icon name="plus" className="uk-margin-small-right" />
                            New Site / Building
                          </a>
                        </li>
                        {Object.keys(sites).map((siteId) => (
                          <li key={siteId}>
                            <a
                              href="#"
                              className="uk-text-truncate"
                              onClick={() => this.handleSite(siteId)}>
                              {sites[siteId].name || 'Unnamed Site / Building'}
                            </a>
                            <ul className="uk-nav-sub">
                              {sites[siteId].components && Object.keys(sites[siteId].components).map((siteComponentId) => (
                                <li key={siteComponentId}>
                                  <a
                                    href="#"
                                    className="uk-text-truncate"
                                    onClick={() => this.handleSiteComponent(siteId, siteComponentId)}>
                                    {sites[siteId].components[siteComponentId].name || 'Unnamed Component'}
                                  </a>
                                </li>
                              ))}
                              <li>
                                <a href="#" onClick={() => this.handleSiteComponent(siteId)}>
                                  <Icon name="plus" className="uk-margin-small-right" />
                                  New Component
                                </a>
                              </li>
                            </ul>
                          </li>
                        ))}
                      </ul>
                    </li>
                    <li className="uk-parent">
                      <a
                        href="#"
                        //onClick={this.handleShowObjects}
                        >
                        Collections / Objects
                      </a>
                      <ul className="uk-nav-sub">
                        <li>
                          <a href="#" onClick={this.handleObject}>
                            <Icon name="plus" className="uk-margin-small-right" />
                            New Collection / Object
                          </a>
                        </li>
                        {Object.keys(objects).map((objectId) => (
                          <li key={objectId}>
                            <a
                              href="#"
                              className="uk-text-truncate"
                              onClick={() => this.handleObject(objectId)}>
                              {objects[objectId].name || 'Unnamed Collection / Object'}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </li>
                    {!isEmpty(unassessedItems) &&
                      <React.Fragment>
                        <li className="uk-nav-divider" />
                        <li>
                          <a href="#" onClick={this.handleShowUnassessedItems}>
                            <span className="uk-flex uk-flex-between uk-flex-middle">
                              Assess
                              <span className="uk-label uk-margin-left">
                                {Object.keys(unassessedItems).length}
                              </span>
                            </span>
                          </a>
                        </li>
                      </React.Fragment>
                    }
                  </ul>
                </div>
              </div>
              <div className="uk-width-2-3@m">
                {visible === 'overview' && this.renderOverview()}
                {visible === 'areas' && this.renderAreas()}
                {visible === 'area' && this.renderArea()}
                {visible === 'sites' && this.renderSites()}
                {visible === 'site' && this.renderSite()}
                {visible === 'site-component' && this.renderSiteComponent()}
                {visible === 'objects' && this.renderObjects()}
                {visible === 'object' && this.renderObject()}
                {visible === 'unassessedItems' && this.renderUnassessedItems()}
                {visible === 'unassessedItem' && this.renderUnassessedItem()}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/ReportEdit/ReportEdit.js